import React from 'react';
import PropTypes from 'prop-types';
import { ModalBody, Form } from 'reactstrap';
import { Formik } from 'formik';
import PrimaryButton from '../buttons/PrimaryButton';
import SecondaryButton from '../buttons/SecondaryButton';
import useStyles from './styles';
import MessageErrorWithTraslation from '../../common/MessageErrorWithTraslation';

const FormModalContent = ({
  onConfirm,
  onHide,
  additionalData: {
    title,
    message,
    confirmText,
    showForm,
    initialValues,
    FormSchema,
    createFormComponent,
    alertError,
    confirmParams,
    showConfirmButton,
    cancelText,
  },
}) => {
  const classes = useStyles();
  return (
    <ModalBody className={classes.container}>
      <h2 className={classes.title}>{title}</h2>
      {message && <p className={classes.message}>{message}</p>}
      <Formik
        initialValues={confirmParams ? confirmParams[0] : initialValues}
        onSubmit={onConfirm}
        validationSchema={FormSchema}
      >
        {({
          handleSubmit,
          isSubmitting,
          ...formikProps
        }) => (
          <Form className={classes.form} onSubmit={handleSubmit}>
            {showForm && createFormComponent(formikProps) }

            <MessageErrorWithTraslation error={alertError} />

            <div className={classes.buttonFooter}>
              {showConfirmButton && <PrimaryButton type="submit" className={classes.button} disabled={isSubmitting}>
                {confirmText}
              </PrimaryButton>}
              <SecondaryButton type="button" onClick={onHide} className={classes.button}>
                {cancelText}
              </SecondaryButton>
            </div>
          </Form>
        )}
      </Formik>
    </ModalBody>
  );
};

FormModalContent.defaultProps = {
  additionalData: {
    title: '',
    message: '',
    confirmText: 'Ok',
    showForm: false,
    initialValues: null,
    FormsSchema: null,
    alertError: null,
    confirmParams: null,
    showConfirmButton: true,
    cancelText: 'Cancelar',
  },
};

FormModalContent.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
  additionalData: PropTypes.shape({
    title: PropTypes.string,
    message: PropTypes.string,
    confirmText: PropTypes.string,
    cancelText: PropTypes.string,
    showForm: PropTypes.bool,
    initialValues: PropTypes.objectOf(PropTypes.string),
    FormSchema: PropTypes.object,
    createFormComponent: PropTypes.func.isRequired,
    alertError: PropTypes.string,
    confirmParams: PropTypes.any,
    showConfirmButton: PropTypes.bool,
  }),
};

export default FormModalContent;
